import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomizedSwitch, Loader } from 'components';
import { systemActions } from 'store';
import { FindLoad } from 'utils';

const GET_ACTION = 'GET_MEMBERS_PORTAL_CONFIG';
const UPDATE_ACTION = 'UPDATE_MEMBERS_PORTAL_CONFIG';

const PORTAL_ACCESS_FIELDS = [
    {
        key: 'sessionNotes',
        title: 'Session Notes',
        desc: 'Allow client contacts to view completed session notes.',
    },
    {
        key: 'progressReports',
        title: 'Progress Reports',
        desc: 'Allow client contacts to view completed progress reports.',
    },
    {
        key: 'abcData',
        title: 'ABC Data',
        desc: 'Allow client contacts to view completed ABC data.',
    },
    {
        key: 'clientNotes',
        title: 'Client Notes',
        desc: 'Allow client contacts to view completed client notes.',
    },
    {
        key: 'intakeForms',
        title: 'Intake Forms',
        desc: 'Allow client contacts to view completed intake forms.',
    },
];

const DEFAULT_CONFIG = {
    sessionNotes: false,
    progressReports: false,
    abcData: false,
    clientNotes: false,
    intakeForms: false,
};

export const MembersPortalSettings = () => {
    const dispatch = useDispatch();
    const config = useSelector((state) => state.system.membersPortalConfig);
    const loading = FindLoad(GET_ACTION);
    const updating = FindLoad(UPDATE_ACTION);
    const [form, setForm] = useState(DEFAULT_CONFIG);

    useEffect(() => {
        dispatch(systemActions.getMembersPortalConfig());
    }, [dispatch]);

    useEffect(() => {
        if (config) {
            setForm({ ...DEFAULT_CONFIG, ...config });
        }
    }, [config]);

    const handleToggle = (key) => {
        const nextValue = !form[key];
        // Optimistic update; the saga refetches the full config and syncs the store.
        setForm((prev) => ({ ...prev, [key]: nextValue }));
        // Partial update — only send the changed field.
        dispatch(systemActions.updateMembersPortalConfig({ [key]: nextValue }));
    };

    if (loading?.length) {
        return <Loader height={350} />;
    }

    return (
        <div className="members-portal-settings">
            {PORTAL_ACCESS_FIELDS.map((field) => (
                <div className="supervision-section space-between-flex-start" key={field.key}>
                    <div>
                        <p className="settings-subsection-title">{field.title}</p>
                        <p className="settings-subsection-desc">{field.desc}</p>
                    </div>
                    <CustomizedSwitch
                        checkedBgColor={'#0C66E4'}
                        checked={form[field.key]}
                        // disabled={!!updating?.length}
                        handleClick={() => handleToggle(field.key)}
                    />
                </div>
            ))}
        </div>
    );
};
